import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-bulk-petition-moderation',
		path: '/admin/bulk_petition_moderation',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin-petition-bulkModeration" */ './index'), {
			exportName: 'AdminBulkPetitionModeration',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['policy', 'supportSenior'],
		},
		frame: true,
		ssr: {
			// switch this to true to enable SSR
			enabled: false,
			seo: false,
		},
	},
];
